<template>
  <svg
    id="eternal-link"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 504.76 409.9"
    class="svg-icon"
  >
    <path
      id="genicon-vote-cast"
      class="cls-1"
      d="m479.15,263.51h-47.08v58.56h17.92c3.87-.36,7.29,2.89,7.68,7.31v14.64c-.39,4.42-3.81,7.68-7.68,7.31H55.79c-3.87.36-7.29-2.89-7.68-7.31v-14.64c.39-4.42,3.81-7.68,7.68-7.31h17.92v-58.56H25.6C11.47,263.49.01,276.58,0,292.73c0,.02,0,.03,0,.05v87.84c-.01,16.16,11.43,29.26,25.55,29.28h453.61c14.13.01,25.59-13.07,25.6-29.23v-87.89c.01-16.16-11.43-29.26-25.55-29.28-.02,0-.04,0-.06,0Zm-72.67,58.56V29.55C406.49,13.24,394.94,0,380.67,0c-.01,0-.02,0-.03,0H125.22c-14.29-.01-25.89,13.21-25.92,29.55v292.51h307.18Zm-240.63-166.56l20.4-23.15c3.32-3.82,8.71-3.83,12.05-.04.04.04.07.09.11.13l32.99,38.06,76.16-86.36c3.32-3.82,8.71-3.83,12.05-.04.04.04.07.09.11.13l20.24,23.33c3.34,3.8,3.35,9.97.03,13.78-.04.04-.07.09-.11.13l-102.63,116.39c-3.32,3.82-8.71,3.83-12.05.04-.04-.04-.07-.09-.11-.13l-59.27-68.34c-3.36-3.77-3.41-9.94-.11-13.78.04-.04.07-.09.11-.13h.03Z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconVotes"
};
</script>

<style scoped></style>
